import styled from '@emotion/styled';
import type { MicrositeProfile } from '~/model';

const Section = styled.section`
	padding: 2rem 1.5rem 4rem;
	background: #f5f5f5;
`;

const List = styled.div`
	max-width: 72rem;
	margin: 0 auto;
	display: grid;
	gap: 1.5rem;
`;

const Card = styled.div`
	display: flex;
	gap: 1rem;
	background: white;
	border: 1px solid #d1d5db;
	padding: 1rem;
`;

const Photo = styled.img`
	width: 9rem;
	height: 9rem;
	object-fit: cover;
`;

const Info = styled.div`
	display: grid;
	gap: 0.25rem;
`;

export default function ProfileBlockZeta({ profiles }: { profiles: MicrositeProfile[] }) {
	if (profiles.length === 0) return null;

	return (
		<Section id="contact">
			<List>
				{profiles.map((profile) => (
					<Card key={profile.email ?? profile.name}>
						{profile.headshot?.medium_1x && <Photo src={profile.headshot.medium_1x} alt={profile.name} />}
						<Info>
							<strong>{profile.name}</strong>
							{profile.title && <span>{profile.title}</span>}
							{profile.phone && <span>{profile.phone}</span>}
							{profile.email && <span>{profile.email}</span>}
						</Info>
					</Card>
				))}
			</List>
		</Section>
	);
}
